<template>
    <section>
        <!-- <div v-if="loading" class="content content-centered">
              <pulse-loader></pulse-loader>
          </div> -->
        <div class="content">
            <div class="boxx">
                <div class="box-body">
                    <div id="details" class="row">
                        <div class="collection_scrollbar">
                            <vue-form :state="formstate" @submit.prevent="onSubmit" class="collection_division_paddi">
                                <div class="row row_paddi_manage">
                                    <div class="col-sm-6">
                                        <validate auto-label class="form-group required-field" :class="fieldClassName(formstate.cdaName)">
                                            <label>Ward / Society / Mohalla</label>
                                            <input maxlength="25" type="text" name="cdaName" class="form-control" required v-model="collectionDivisions.cdaName" placeholder="Ward / Society / Mohalla" pattern="^[a-zA-Z][a-zA-Z0-9 @./#+-_]{0,25}[^\s]$" />
                                            <field-messages name="cdaName" show="$touched || $submitted" class="form-control-feedback validation_msg">
                                                <div slot="required">
                                                    Ward / Society / Mohalla is a required field
                                                </div>
                                                <div slot="pattern">
                                                    Alphabets/Numbers/Special Characters are allowed.
                                                </div>
                                            </field-messages>
                                        </validate>
                                    </div>
    
                                    <!-- <div class="col-sm-6">
                        <validate auto-label class="form-group required-field" :class="fieldClassName(formstate.surveyorId)">
                          <label>Surveyor</label>
                          <select required v-model="collectionDivisions.surveyorId" name="surveyorId" class="form-control">
                            <option value="" disabled>Select Surveyor</option>
                            <option v-for="(surveyorId, index) in surveyor" :key="index" :value="surveyorId._id">
                              {{ surveyorId.firstName }} {{ surveyorId.lastName }}</option>
                          </select>
                          <field-messages name="surveyorId" show="$touched || $submitted" class="form-control-feedback validation_msg">
                            <div slot="required">Surveyor is a required field</div>
                          </field-messages>
                        </validate>
                      </div> -->
                                </div>
    
                                <button type="button" class="add_more_btn mr-2 btn gradientbt" @click="addLineInfo()">
                                    Add Line
                                </button>
                                <button type="button" class="add_more_btn mr-2 btn gradientbt" v-if="showLine" @click="showLine = false">
                                    Remove Line
                                </button>
    
                                <div v-if="showLine" class="row">
                                    <button type="button" class="add_more_btn mr-2 btn gradientbt" @click="addMore()" :disabled="!(formstate.$dirty && formstate.$valid)" v-if="$route.params && !$route.params._id">
                                        Add More
                                    </button>
                                    <div class="linesadded_row" v-for="(lineTowerHouse, index) in this.collectionDivisions
                          .lineTowerHouse" :key="index">
                                        <div class="linesadded_wrp">
                                            <label>Line / Tower Name</label>
                                            <div class="linesadded_inner">
                                                <validate auto-label class="form-group required-field" :class="fieldClassName(lineTowerHouse.name)">
                                                    <input :required="collectionDivisions.lineTowerHouse[index].name == '' ? true : false" maxlength="25" type="text" :id="index" :name="
                                  'collectionDivisions.lineTowerHouse[' +
                                    index +
                                    '][\'name\']'
                                " class="form-control lineTower" v-model="lineTowerHouse.name" placeholder="Line / Tower" pattern="^[a-zA-Z][a-zA-Z0-9 @./#+-_]{0,25}[^\s]$" />
                                                    <field-messages :name="
                                  'collectionDivisions.lineTowerHouse[' +
                                    index +
                                    '][\'name\']'
                                " show="$touched || $submitted" class="form-control-feedback">
                                                        <div slot="required">
                                                            Line/Tower name is required.
                                                        </div>
                                                        <div slot="pattern">
                                                            Alphabets/Numbers/Special Characters are allowed.
                                                        </div>
                                                    </field-messages>
                                                </validate>
                                            </div>
                                        </div>
                                        <div class="houses_label_wrp">
                                            <label>Houses:</label>
                                        </div>
                                        <div class="houses_wrp">
                                            <div class="flex" v-for="(house, houseIndex) in lineTowerHouse.houses" :key="houseIndex">
                                                <div>
                                                    <validate auto-label class="form-group required-field" :class="fieldClassName(house.hnNo)">
                                                        <input :required="lineTowerHouse.houses[houseIndex].hnNo == '' ? true : false" maxlength="10" type="text" :name="'' + houseIndex + index + ''" class="form-control" v-model="house.hnNo" placeholder="H No." pattern="^[a-zA-Z]|[0-9][a-zA-Z0-9 @./#+-_]{0,10}[^\s]$" />
                                                        <field-messages :name="'' + houseIndex + index + ''" show="$touched || $submitted" class="form-control-feedback">
                                                            <div slot="required">
                                                                House Number is required.
                                                            </div>
                                                            <div slot="pattern">
                                                                Alphabets/Numbers/Special Characters are
                                                                allowed.
                                                            </div>
                                                        </field-messages>
                                                    </validate>
                                                </div>
                                                <button type="button" class="mr-2 btn gradientbt" @click="removeHouse(index, houseIndex)" v-show="lineTowerHouse.houses.length > 1">
                                                    -
                                                </button>
                                            </div>
                                            <button type="button" class="mr-2 btn gradientbt" @click="addMoreHouses(index)" :disabled="!(formstate.$dirty && formstate.$valid)" v-if="$route.params && !$route.params._id">
                                                +
                                            </button>
                                        </div>
    
                                        <button type="button" class="add_more_btn mr-2 btn gradientbt" @click="remove(index)" v-show="collectionDivisions.lineTowerHouse.length > 1">
                                            Remove
                                        </button>
                                    </div>
                                </div>
                            </vue-form>
                        </div>
                        <div class="col-sm-12 text-right">
                            <!-- <router-link :to="{ name: 'wasteCollectionAreaDetails' }"> -->
                            <button @click="onCancel" class="mr-5 btn btn-default" type="button">
                                Cancel
                            </button>
                            <!-- </router-link> -->
                            <button class="mr-2 btn gradientbt" type="submit" @click="createCollectionDivisions" :disabled="!(formstate.$dirty && formstate.$valid)" v-if="$route.params && !$route.params._id">
                                Save
                            </button>
                            <button class="btn gradientbt mr-5" type="submit" @click="updateCollectionDivisions" :disabled="
                      !(formstate.$dirty && formstate.$valid) &&
                        lineList &&
                        houseList
                    " v-if="$route.params && $route.params._id">
                                Update
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
    </template>
    
    <script>
    import store from "../../../store";
    import {
        formService,
        eventBus,
        wasteCollectionAreaService,
    } from "../../../services";
    import {
        ServerTable,
        EVENTS
    } from "../../../config";
    import {
        USER_ROLES
    } from "../../../config";
    import {
        mapState
    } from "vuex";
    import swal from "sweetalert2";
    
    export default {
        name: "collectionDivisionCreate",
        data() {
            return {
                show: false,
                showLine: false,
                input: "",
                items: [],
                details: {},
                detailss: {},
                formstate: {},
                collectionDivisions: {
                    lineTowerHouse: [{
                        name: "",
                        houses: [{
                            hnNo: "",
                        }, ],
                    }, ],
                },
                collectionDivisionsData: {},
                surveyor: [],
                mode: "create",
                line: {},
                lineList: true,
                houseList: true,
            };
        },
        // mounted: function () {
        // this.getSurveyoys()
    
        // },
        methods: {
            fieldClassName: formService.fieldClassName,
            addMore() {
                this.lineList = true;
                this.collectionDivisions.lineTowerHouse.push({
                    name: "",
                    houses: [{
                        hnNo: "",
                    }, ],
                });
                setTimeout(() => {
                    document
                        .getElementById(this.collectionDivisions.lineTowerHouse.length - 1)
                        .scrollIntoView({
                            block: "center",
                        });
                }, 300);
            },
            remove(index) {
                this.lineList = false;
                this.collectionDivisions.lineTowerHouse.splice(index, 1);
            },
            addMoreHouses(lineTowerIndex) {
                this.houseList = true;
                this.collectionDivisions.lineTowerHouse[lineTowerIndex].houses.push({
                    hnNo: "",
                });
            },
            removeHouse(lineTowerIndex, houseIndex) {
                this.houseList = false;
                this.collectionDivisions.lineTowerHouse[lineTowerIndex].houses.splice(
                    houseIndex,
                    1
                );
            },
            addColletion() {
                this.show = true;
                this.collectionForm.reset();
                this.mode = "create";
            },
            addToItems() {
                if (!this.input) {
                    return;
                }
                this.items.push(this.input);
                this.input = "";
            },
            addLineInfo() {
                this.showLine = true
            },
            getWasteCollectionDetails() {
                this.loading = true;
                return wasteCollectionAreaService
                    .getwasteCollection(this.$route.params._id)
                    .then((response) => {
                        this.details = response.data.response;
                        this.loading = false;
                    })
                    .catch((error) => {
                        this.loading = false;
                        console.error(
                            "wasteCollectionDetails.getWasteCollection-error:",
                            error
                        );
                        // this.$snotify.error('Update user failed', 'Error!');
                    });
            },
    
            getcollectionDivisionDetails() {
                this.loading = true;
                return wasteCollectionAreaService
                    .getCollectionDivisionList(this.$route.params._id)
                    .then((response) => {
                        this.detailss = response.data.response;
                        this.loading = false;
                    })
                    .catch((error) => {
                        this.loading = false;
                        console.error("UserDetails.updateUser-error:", error);
                        // this.$snotify.error('Update user failed', 'Error!');
                    });
            },
            // getSurveyoys() {
            //   this.loading = true;
            //   return wasteCollectionAreaService
            //     .getSurveyoysList('')
            //     .then(response => {
            //       this.surveyor = response.data.response;
            //       this.loading = false;
            //     })
            //     .catch(error => {
            //       this.loading = false;
            //       console.error('UserDetails.updateUser-error:', error);
            //       // this.$snotify.error('Update user failed', 'Error!');
            //     });
            // },
            createCollectionDivisions() {
                this.loading = true;
                this.collectionData = {};
                this.collectionDivisionsData["caId"] = this.$route.params.wcaId;
                this.collectionDivisionsData["cdName"] = this.collectionDivisions.cdaName;
                this.collectionDivisionsData[
                    "cdaName"
                ] = this.collectionDivisions.cdaName;
                if (this.showLine) {
                    this.collectionDivisionsData[
                        "lineTowerHouse"
                    ] = this.collectionDivisions.lineTowerHouse;
                }
                // this.collectionDivisionsData['surveyorId'] = this.collectionDivisions.surveyorId
                this.collectionDivisionsData["userId"] = store.state.auth.user._id;
                //   this.collectionDivisionsData['cityId']= this.collectionDivisions.cityId
                return wasteCollectionAreaService
                    .addcollectionDivision(this.collectionDivisionsData)
                    .then((response) => {
                        this.loading = false;
                        this.flash = false;
                        this.show = false;
                        this.$snotify.success("collection division  added!", "Success!");
                        this.$router.push({
                            name: "wasteCollectionAreaDetails",
                            params: {
                                _id: this.$route.params.wcaId,
                            },
                            // props: this.details,
                        });
                    })
                    .catch((error) => {
                        this.loading = false;
                        if (error.data && error.data.message) {
                            this.$snotify.error(error.data.message, "Error!");
                        }
                    });
            },
    
            getCollectiondivisionById() {
                this.show = true;
                return wasteCollectionAreaService
                    .getCollectionDivisionById(this.$route.params._id)
                    .then((response) => {
                        // this.collectionDivisions = response.data.response
                        this.collectionId = response.data.response._id;
                        let data = response.data.response;
                        this.collectionDivisions["cdaName"] = data.cdaName;
                        // this.collectionDivisions['surveyorId'] = data.surveyorId._id
                        this.collectionDivisions["lineTowerHouse"] = data.lineTowerHouse;
                        // this.collectionDivisions['cdName'] = data.cdName
                        // this.collectionDivisions['cdName'] = data.cdName
                        this.$store.dispatch(
                            "setBreadcrumbTitle",
                            this.collectionDivisions.cdaName
                        );
                    });
            },
    
            updateCollectionDivisions() {
                this.loading = true;
                // this.collectionDivisions = {}
                this.collectionData = {};
                this.collectionDivisionsData["caId"] = this.$route.params.wcaId;
                this.collectionDivisionsData["cdName"] = this.collectionDivisions.cdaName;
                this.collectionDivisionsData[
                    "cdaName"
                ] = this.collectionDivisions.cdaName;
                this.collectionDivisionsData["lineTowerHouse"] = [];
                for (let i = 0; i < this.collectionDivisions.lineTowerHouse.length; i++) {
                    this.line = {};
                    this.line.name = this.collectionDivisions.lineTowerHouse[i]["name"];
                    this.collectionDivisionsData["lineTowerHouse"][
                        "name"
                    ] = this.collectionDivisions.lineTowerHouse[i]["name"];
                    this.line["houses"] = [];
                    for (
                        let j = 0; j < this.collectionDivisions.lineTowerHouse[i].houses.length; j++
                    ) {
                        let house = {};
                        house.hnNo = this.collectionDivisions.lineTowerHouse[i]["houses"][j][
                            "hnNo"
                        ];
                        this.line["houses"].push(house);
                    }
                    this.collectionDivisionsData["lineTowerHouse"].push(this.line);
                }
                // this.collectionDivisionsData['surveyorId'] = this.collectionDivisions.surveyorId
                this.collectionDivisionsData["userId"] = store.state.auth.user._id;
                // this.collectionDivisionsData['cityId']= this.collectionDivisions.cityId
                this.collectionDivisionsData["_id"] = this.collectionId;
                return wasteCollectionAreaService
                    .updatecollectionDivision(this.collectionDivisionsData)
                    .then((response) => {
                        this.loading = false;
    
                        this.show = false;
                        this.flash = false;
                        // this.$ref.collectionForm.reset()
                        this.$snotify.success("collection division updated!", "Success!");
                        this.$router.push({
                            name: "wasteCollectionAreaDetails",
                            params: {
                                _id: this.$route.params.wcaId,
                            },
                            // props: this.details,
                        });
                    })
                    .catch((error) => {
                        this.loading = false;
                        this.$snotify.error(error, "Error!");
                        if (error.data.message.includes("Duplicate")) {
                            var errorMessage = "This wasteCollectionArea name already exist";
                            this.$snotify.error(errorMessage, "Error!");
                        }
                    });
            },
            editInfo(data) {
                this.$router.push({
                    name: "wasteCollectionAreaCreate",
                    params: {
                        _id: data._id,
                    },
                    // props: this.details,
                });
            },
    
            onCancel() {
                this.$router.push({
                    name: "wasteCollectionAreaDetails",
                    params: {
                        _id: this.$route.params.wcaId,
                    },
                    // props: this.details,
                });
            },
        },
    
        created() {
            const promises = [];
            this.loading = true;
    
            if (this.$route.params && this.$route.params._id) {
                promises.push(this.getCollectiondivisionById());
                //   promises.push(this.getWasteCollectionDetails());
                //   promises.push(this.getcollectionDivisionDetails());
            }
            Promise.all(promises)
                .then(() => {
                    this.loading = false;
                    this.ready = true;
                })
                .catch(() => {
                    this.loading = false;
                });
        },
        // fieldClassName: function (field) {
        //   if (!field) {
        //     return '';
        //   }
        //   if ((field.$touched || field.$submitted) && field.$valid) {
        //     return 'has-success';
        //   }
        //   if ((field.$touched || field.$submitted) && field.$invalid) {
        //     return 'has-danger';
        //   }
        // },
    };
    </script>
    
    <style scoped>
    .collection_division {
        padding: 15px;
    }
    
    .collection_division table {
        font-family: arial, sans-serif;
        border-collapse: collapse;
        width: 100%;
    }
    
    .collection_division td,
    .collection_division th {
        border: 1px solid #dddddd;
        text-align: left;
        padding: 8px;
    }
    
    .collection_division_inner {
        padding-top: 20px;
    }
    
    .overlay {
        position: fixed;
        z-index: 9998;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, 0.5);
    }
    
    .sidepop {
        position: fixed;
        width: 735px;
        z-index: 9999;
        margin: 0 auto;
        padding: 20px 30px;
        background-color: #fff;
        right: 0;
        top: 0;
        height: 100%;
    }
    
    /* .toggle {
      position: relative;
      z-index: 999999;
    } */
    .collection_division_pop_wrp h2 {
        font-size: 22px;
        font-weight: 600;
        margin-top: 0;
        margin-bottom: 20px;
    }
    
    .collection_input input {
        width: 100%;
        border: 2px solid #ddd;
        padding: 10px;
        border-radius: 0px;
    }
    
    .collection_input p {
        margin-bottom: 5px;
        font-weight: 600;
    }
    
    .collection_input input:focus {
        outline: 0;
        border: 2px solid #ddd;
    }
    
    .houses_boxs {
        padding-left: 15px;
        padding-right: 15px;
    }
    
    .houses_boxs input {
        margin-right: 15px;
        width: 85px;
        border: 2px solid #ddd;
        padding: 10px;
        border-radius: 0px;
        margin-bottom: 15px;
    }
    
    .houses_boxs input:focus {
        outline: 0;
        border: 2px solid #ddd;
    }
    
    .houses_boxs p {
        margin-bottom: 5px;
        font-weight: 600;
    }
    
    .houses_boxs_wrp {
        margin-top: 20px;
    }
    
    .save_btn button {
        background: #35A2FE;
        color: #fff;
        padding: 10px 20px;
        text-align: center;
        border-radius: 5px;
        border: 2px solid #35A2FE;
        margin-top: 20px;
    }
    
    .houses_boxs button {
        background: #35A2FE;
        color: #fff;
        padding: 10px;
        text-align: center;
        border: 2px solid #35A2FE;
        margin-bottom: 15px;
    }
    
    .collection_division_pop_wrp .toggle {
        border: 0;
        background: transparent;
        box-shadow: none;
        position: absolute;
        right: 10px;
        top: 21px;
    }
    
    .collection_division_pop_wrp .toggle svg {
        width: 20px;
        height: 20px;
    }
    
    .container {
        display: block;
    }
    
    .area-name-bg {
        width: 100%;
        display: flex;
        flex-wrap: wrap;
        background: rgb(225 225 225);
        padding: 10px 15px;
        padding-bottom: 0px;
        box-shadow: 0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1);
    }
    
    .area-name div {
        width: 20%;
        word-wrap: break-word;
        padding: 0px 5px;
    }
    
    .details-card {
        display: flex;
        border: 2px solid #ddd;
        margin-top: 3px;
        padding: 10px;
        margin-bottom: 15px;
        padding-bottom: 0px;
        box-shadow: 0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1);
        position: relative;
    }
    
    .scroll-items {
        overflow-y: auto;
        scroll-behavior: smooth;
        height: calc(100vh - 295px);
    }
    
    .scroll-items::-webkit-scrollbar {
        width: 5px;
    }
    
    .scroll-items::-webkit-scrollbar-thumb {
        background: #888;
    }
    
    .edit {
        cursor: pointer;
        height: 20px;
        width: 53px;
        display: contents;
    }
    
    .collection_division_info {
        padding: 15px 30px;
        padding-right: 0px;
    }
    
    .area_inner h4 {
        font-weight: 600;
        font-size: 16px;
        margin: 0px;
    }
    
    .edit a {
        color: #35A2FE;
        font-weight: 600;
    }
    
    .area_inner_addnew h4 {
        font-weight: 600;
    }
    
    .area_inner_addnew {
        padding-top: 20px;
    }
    
    .area_inner_addnew .toggle {
        cursor: pointer;
        margin-bottom: 0px;
        position: relative;
        top: 2px;
        display: inline;
        background: #35A2FE;
        padding: 5px 10px;
        color: #fff;
        border-radius: 5px;
        font-weight: normal;
    }
    
    .gradientbt {
        border: 2px solid #35A2FE;
        height: 35px;
    }
    
    .gradientbt:focus {
        border: 2px solid #35A2FE;
        color: #35A2FE;
        background: #fff;
        outline: none;
    }
    .gradientbt:active:focus, .gradientbt:focus {
    outline: 0px auto -webkit-focus-ring-color;
    outline-offset: 0px;
}
    
    .houses_wrp {
        display: flex;
        flex-wrap: wrap;
    }
    
    .linesadded_row .flex {
        flex: 0 0 13%;
        margin-right: 10px;
        display: flex;
        align-items: flex-start;
        margin-bottom: 15px;
    }
    
    .linesadded_row .flex .form-group {
        margin-bottom: 0;
    }
    
    .houses_label_wrp {
        display: flex;
        align-items: center;
    }
    
    .add_more_btn {
        margin-bottom: 15px;
    }
    
    .form_scrollbar {
        overflow: auto;
        height: calc(100vh - 150px);
        overflow-x: hidden;
    }
    
    .form_scrollbar::-webkit-scrollbar {
        width: 5px;
        height: 0;
    }
    
    .form_scrollbar::-webkit-scrollbar-thumb {
        background: #888;
    }
    
    .details-card h5 {
        font-weight: 600;
        margin: 0;
    }
    
    .details-card p {
        margin-bottom: 2px;
    }
    
    .collection_row .col-sm-3 {
        width: 20%;
        margin-bottom: 10px;
    }
    
    .details-card button {
        background: transparent;
        border: 0;
        color: #35A2FE;
        z-index: 2;
        position: relative;
    }
    
    .area_inner_addnew_paddi {
        padding-right: 30px;
    }
    
    .edit_icons {
        position: absolute;
        right: 45px;
        flex: 0 0 5%;
    }
    
    .details-card .d-flex {
        flex: 0 0 95%;
    }
    
    .area_inner_side {
        flex: 0 0 95%;
        display: flex;
    }
    
    .edit_side {
        flex: 0 0 5%;
    }
    
    .edit_side button {
        box-shadow: none;
        border: 0;
        background: transparent;
        color: #fff;
    }
    
    .collection_division_paddi {
        padding: 0px 30px;
    }
    
    .row_paddi_manage {
        margin-left: -30px;
        margin-right: -30px;
        margin-bottom: 15px;
    }
    
    .collection_scrollbar {
        overflow: auto;
        height: calc(100vh - 227px);
    }
    
    .collection_scrollbar::-webkit-scrollbar {
        width: 5px;
    }
    
    .collection_scrollbar::-webkit-scrollbar-thumb {
        background: #888;
    }
    
    .form-control-feedback.validation_msg {
        left: 0;
        width: 100%;
        text-align: left;
        position: relative;
        top: 0;
        height: auto;
    }
    
    .required-field>label::after {
        content: "*";
        color: red;
        margin-left: 0.25rem;
    }
    
    .required-field-asterisk {
        color: red;
        margin-left: 0.25rem;
    }
    
    .lineTower {
        width: 49%;
    }
    
    .input-error {
        color: #dd4b39;
    }
    
    .boxx {
        position: relative;
        border-radius: 3px;
        background: #ffffff;
        border-top: 3px solid #35A2FE;
        /* margin-bottom: 20px; */
        width: 100%;
        box-shadow: 0 1px 1px rgba(0, 0, 0, 0.1);
    }
    </style>
    


// WEBPACK FOOTER //
// collectionDivisionCreate.vue?07605d2f